import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { Logo } from "../components/Header";

export default function AdminLogin() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hh_admin_token", data.token);
      toast.success(t("admin.login_success"));
      navigate("/admin");
    } catch {
      toast.error(t("admin.login_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B132B] flex items-center justify-center px-6 grain relative" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="w-full max-w-sm">
        <div className="flex justify-center mb-10"><Logo /></div>
        <div className="rounded-3xl border border-white/10 bg-[#111D38] p-8">
          <div className="w-12 h-12 rounded-2xl bg-[#E65100]/15 border border-[#E65100]/30 flex items-center justify-center mb-5">
            <Lock className="w-6 h-6 text-[#F4511E]" />
          </div>
          <h1 className="font-head font-black text-xl text-white">{t("admin.login_title")}</h1>
          <p className="text-xs text-slate-500 mt-1 mb-7">{t("admin.login_sub")}</p>
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="admin-email" type="email" required placeholder="Email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input data-testid="admin-password" type="password" required placeholder="Password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} />
            <button type="submit" data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full justify-center !py-3 disabled:opacity-50">
              {t("login.submit")}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
